import {API} from 'aws-amplify';
import moment from "moment";
import LogRocket from 'logrocket';

function getMyInitiAgrupamento(filial) {
    var date = new Date();
    if (process.env.REACT_APP_EDIT_AUX_DATA_CORRENTE === 'true') {
        var firstLim = date.getMonth()
        var lastLim = date.getMonth() + 1
    }else{
        var firstLim = date.getMonth() - 1
        var lastLim = date.getMonth()
    }

    var firstDay = new Date(date.getFullYear(), firstLim, 1);
    var lastDay = new Date(date.getFullYear(), lastLim, 0);

    let myInitDb = {
        body: {
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_auxiliar_padrao_silver",
            "command": "find",
            "database": process.env.REACT_APP_DATABASE,
            sort: [["mes_apur", 1], ["nome", 1]],
            limit: 10000,
            "query":
                {
                    filial_nome: filial.filial_name,
                    mes_apur: {
                        "$gte": {"$date": moment(firstDay).format("YYYY-MM-DD") + "T00:00:00.000Z"},
                        "$lte": {"$date": moment(lastDay).format("YYYY-MM-DD") + "T00:00:00.000Z"}
                    }
                }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}



function getMyInitiUserStore() {

    let myInitDb = {
        body: {
            "collection": "users_permission",
            "command": "find",
            "database": process.env.REACT_APP_DATABASE,
            sort: [["nome", 1]],
            "query":
                {
                    user: localStorage.getItem('tbClientes'),
                }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}


function getMyInitiDistinct(query) {
    let myInitDb = {
        body: {
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_auxiliar_padrao_silver",
            "command": "distinct",
            "database": process.env.REACT_APP_DATABASE,
            "query": query,
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

async function callSetIndividual(valores) {
    var campos = valores.filter(colunas => colunas.type == 'row' && colunas.editado == true);
    var json = "";
    for await (let campos_dentro of campos) {
        json = {
            body: {
                "database": process.env.REACT_APP_DATABASE,
                "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_auxiliar_padrao_silver",
                "command": "update_many",
                "query": {
                    "_id": {"$oid": campos_dentro._id}
                },
                "update": {
                    "$set": {
                        "vendas_adicionais": parseFloat(campos_dentro.vendas_adicionais) * 1.000000000000001,
                        "vendas_servicos": parseFloat(campos_dentro.vendas_servicos) * 1.000000000000001,
                        "result_qtde_servico": parseFloat(campos_dentro.result_qtde_servico) * 1.000000000000001,
                        "dias_media": parseFloat(campos_dentro.dias_media) * 1.000000000000001,
                        "result_desafio_mensal": parseFloat(campos_dentro.result_desafio_mensal) * 1.000000000000001,
                    }
                }
            },
            headers: {
                'Access-Control-Allow-Headers': 'Content-Type',
                'Access-Control-Allow-Origin': 'http://localhost:3000',
                'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
                drtoken: localStorage.getItem('token')
            }
        };
        await setUpdate(json)
    }
    return true;
}

async function callSetComment(comment) {
    console.log(comment);
    let json = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_auxiliar_padrao_silver",
            "command": "update_many",
            "query": {
                "_id": {"$oid": comment._id}
            },
            "update": {
                "$set": {
                    "comentario": comment.comentario
                }
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    await setUpdate(json)
    return true;
}

async function setUpdate(json) {
    await API.post('dr', '/mongoDB', json).then(response => {
        //new Promise(r => setTimeout(r, 5000));
        return response;
    }).catch(erro => {
        LogRocket.captureException(erro);
    })
}

export default {
    getRows: (filial) =>
        API.post('dr', '/mongoDB', getMyInitiAgrupamento(filial)).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),


    getUsersStore: () =>
        API.post('dr', '/mongoDB', getMyInitiUserStore('filial_nome')).then(response => {
            localStorage.setItem('type_user_aux_padrao', response.response[0].type);
            return response.response[0].stores;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    getFilial: () =>
        API.post('dr', '/mongoDB', getMyInitiDistinct('filial_nome')).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    setRh: (valores) => {
        const promise = new Promise((resolve, reject) => {
            try {
                resolve(callSetIndividual(valores))
            } catch (e) {
                reject(e)
            }
        })

        return promise.then(resposta => {
            return resposta;
        }, erro => {
            LogRocket.captureException(erro)
        })
    },

    setComment: (comment) => {
        const promise = new Promise((resolve, reject) => {
            try {
                resolve(callSetComment(comment))
            } catch (e) {
                reject(e)
            }
        })

        return promise.then(resposta => {
            return resposta;
        }, erro => {
            LogRocket.captureException(erro)
        })
    },


};
